import React from "react";
import { UrlProvider } from "../../../utils/UrlProvider";
import "slick-carousel/slick/slick.css";
import PropTypes from "prop-types";

const SliderButton = ({ ind, backgroundImg, button_icon, previous, next }) => {

    return (<div>
        <button
            className="md:w-[6vw] md:h-[6vw] w-[8vw] h-[8vw] rounded-full"
            onClick={ind === 0 ? previous : next}
            style={{backgroundImage: `url(${UrlProvider(backgroundImg?.url)})`,
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                justifyContent: "center",
                justifyItems: "center",
            }}
        >
            <span className="absolute inset-0 bg-white bg-opacity-[80%] rounded-full" ></span>
            <img
                src={UrlProvider(button_icon?.url)}
                alt="button icon"
                className="absolute w-[6vw] md:w-[2.5vw] md:mt-[1.7vw] mt-[1vw]"
            />
        </button>
    </div>)
}

SliderButton.propTypes = {
    ind: PropTypes.number,
    storiesData: PropTypes.object,
    backgroundImg: PropTypes.object,
    button_icon: PropTypes.object,
    previous: PropTypes.func,
    next: PropTypes.func,
};

export default SliderButton;